import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Services from "./pages/Services";
import StudioLife from "./pages/StudioLife";
import StudioLifeDetail from "./pages/StudioLifeDetail";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import AdminInquiries from "./pages/AdminInquiries";
import AdminProjects from "./pages/AdminProjects";
import AdminProjectEditor from "./pages/AdminProjectEditor";
import AdminMedia from "./pages/AdminMedia";
import AdminSettings from "./pages/AdminSettings";
import AdminEmailSettings from "./pages/AdminEmailSettings";
import AdminClients from "./pages/AdminClients";
import AdminDashboard from "./pages/AdminDashboard";
import AdminArticles from "./pages/AdminArticles";
import AdminArticleEditor from "./pages/AdminArticleEditor";
import AdminServicesPage from "./pages/AdminServicesPage";
import AdminRecognition from "./pages/AdminRecognition";
import AdminStudio from "./pages/AdminStudio";
import AwardsArchive from "./pages/AwardsArchive";

const Chrome = ({ children }) => {
    const { pathname } = useLocation();
    const hide = pathname.startsWith("/admin");
    return (
        <>
            {!hide && <Nav />}
            {children}
            {!hide && <Footer />}
        </>
    );
};

// Legacy /journal/:slug → /studio-life/:slug (preserve deep links)
const JournalSlugRedirect = () => {
    const { slug } = useParams();
    return <Navigate to={`/studio-life/${slug}`} replace />;
};

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                    <Chrome>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/projects" element={<Projects />} />
                            <Route path="/projects/:slug" element={<ProjectDetail />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/studio-life" element={<StudioLife />} />
                            <Route path="/studio-life/:slug" element={<StudioLifeDetail />} />
                            {/* Legacy redirects — keep old /journal links working */}
                            <Route path="/journal" element={<Navigate to="/studio-life" replace />} />
                            <Route path="/journal/:slug" element={<JournalSlugRedirect />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/awards/archive" element={<AwardsArchive />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
                            <Route path="/admin/dashboard" element={<AdminDashboard />} />
                            <Route path="/admin/inquiries" element={<AdminInquiries />} />
                            <Route path="/admin/clients" element={<AdminClients />} />
                            <Route path="/admin/settings/email" element={<AdminEmailSettings />} />
                            <Route path="/admin/projects" element={<AdminProjects />} />
                            <Route path="/admin/projects/new" element={<AdminProjectEditor />} />
                            <Route path="/admin/projects/:slug/edit" element={<AdminProjectEditor />} />
                            <Route path="/admin/articles" element={<AdminArticles />} />
                            <Route path="/admin/articles/new" element={<AdminArticleEditor />} />
                            <Route path="/admin/articles/:slug/edit" element={<AdminArticleEditor />} />
                            <Route path="/admin/services-page" element={<AdminServicesPage />} />
                            <Route path="/admin/recognition" element={<AdminRecognition />} />
                            <Route path="/admin/studio" element={<AdminStudio />} />
                            <Route path="/admin/media" element={<AdminMedia />} />
                            <Route path="/admin/settings" element={<AdminSettings />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Chrome>
                </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
